<template>
  <div>
    <div class="guide-intro">
      Tiger Casinoでは各通貨ごとに独立したウォレットを採用しており、<br>お客様が簡単かつ効率的に資金を管理できるシステムとなっております。
    </div>
    <tiger-category-strip :items="categoryLinks" />

    <section id="wallet-switch" class="panel">
      <h2>ウォレットの利用・切り替え方法</h2>
      <div class="bodytext" v-text="'利用・切り替え方法はとても簡単です\n「残高」を押し、利用したいウォレットを選択するだけで切り替えが可能です'" />
      <div class="panel-shots">
        <div class="screenshot-grid">
          <tiger-shot src="sup/help/wallet_switch_1.webp" />
          <tiger-shot src="sup/help/wallet_switch_2.webp" />
        </div>
      </div>
    </section>

    <section id="wallet-kinds" class="panel">
      <h2>ウォレットの種類一覧</h2>
      <div class="wallet-types">
        <a v-for="item in walletTypes" :key="item.id" :href="`#${item.id}`" @click.prevent="scrollToSection(item.id)">
          {{ item.label }}
        </a>
      </div>
    </section>

    <section v-for="wallet in wallets" :id="wallet.id" :key="wallet.id" class="panel">
      <h2>{{ wallet.title }}</h2>
      <div class="bodytext" v-text="wallet.body" />
      <div class="panel-shots">
        <div class="screenshot-grid one">
          <tiger-shot :src="wallet.image" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import TigerCategoryStrip from './tigerCategoryStrip.vue'
import TigerShot from './tigerShot.vue'

const categoryLinks = [
  { id: 'wallet-switch', label: '切り替え方法' },
  { id: 'wallet-kinds', label: 'ウォレットの種類' },
  { id: 'wallet-jpy', label: '現金ウォレット' },
  { id: 'wallet-crypto', label: '仮想通貨ウォレット' },
  { id: 'wallet-bonus', label: 'BONUSウォレット' },
  { id: 'wallet-display', label: 'ゲーム内の表示通貨' }
]

const walletTypes = [
  { id: 'wallet-jpy', label: '現金ウォレット（JPY）' },
  { id: 'wallet-crypto', label: '仮想通貨ウォレット' },
  { id: 'wallet-bonus', label: 'ボーナスウォレット' }
]

const wallets = [
  {
    id: 'wallet-jpy',
    title: '現金ウォレット（JPY）',
    body: '・「JPYウォレット」は法定通貨（日本円）のウォレットです。\n\n・仮想通貨でご入金された資金、またはBONUSウォレットの賭け条件を達成した資金は、「JPYウォレット」に移行可能です。\n\n・ボーナスを利用しない場合、入金額の出金条件は「入金額の１倍」です。',
    image: 'sup/help/wallet_jpy.webp'
  },
  {
    id: 'wallet-crypto',
    title: '仮想通貨ウォレット',
    body: '・「仮想通貨ウォレット」は、各通貨ごとに独立したウォレットを採用しています。\n\n・仮想通貨で入金した場合は一切の両替は行われず、入金した通貨がそのまま対応するウォレットに反映され、プレイできます。\n\n・ボーナスを利用しない場合、入金額の出金条件は「入金額の１倍」です。\n\n・対応している仮想通貨は以下の通りです。',
    image: 'sup/help/wallet_crypto.webp'
  },
  {
    id: 'wallet-bonus',
    title: 'BONUSウォレット',
    body: '・入金不要ボーナス・キャッシュバックなど、プロモーションで獲得するボーナスは、「BONUSウォレット」に反映されます。\n\n・「BONUSウォレット」の残高を利用する場合、特別な禁止ゲームやベット額制限、反映率が適用されます。詳細については、プロモーション一般利用規約をご参照ください。\n\n・賭け条件はプロモーションによって異なり、条件達成後、ご自身でお好きな通貨ウォレットに移行していただき、出金が可能です。\n\n・現金ウォレット（JPY）または仮想通貨ウォレットで入出金を行う時点で、BONUSウォレット内の残高が削除されますのでご注意ください。\n\nボーナスウォレットの残高を出金する場合は、ボーナスウォレット内で設定されている出金条件を満たす必要があります。\nなお、異なるウォレットの残高を合算して出金条件を満たすことはできません。\n各ウォレットごとに設定されている条件をご確認のうえ、ご利用ください。',
    image: 'sup/help/wallet_bonus.webp'
  },
  {
    id: 'wallet-display',
    title: 'ゲーム内の表示通貨',
    body: '・ゲームにアクセスする際に、ゲーム内に表示される通貨単位を「JPY」または「USD」から選択することができます。\n\n・表示通貨はゲーム内の金額単位の表示のみを変更するものです。実際のベットや配当の受け取りは、選択しているウォレットの通貨で行われます。\n\n・例）USDTウォレットを使用し、表示設定を「JPY」にした場合、ゲーム内ではJPY（円）でプレイしているように見えますが、USDTを使用して決済が行われています。\n\n※ゲームプロバイダーによって、USD に対応していない場合があります。',
    image: 'sup/help/wallet_display.webp'
  }
]

export default {
  name: 'TigerWallet',
  components: {
    TigerCategoryStrip,
    TigerShot
  },
  data() {
    return {
      categoryLinks,
      walletTypes,
      wallets
    }
  },
  methods: {
    scrollToSection(id) {
      const target = document.getElementById(id)
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    }
  }
}
</script>
